import { FC } from "react";

type ChartWrapperPropsWithChildren = {
  heightClass?: string;
  children: React.ReactNode;
}

const ChartWrapper: FC<ChartWrapperPropsWithChildren> = ({ children, heightClass = '' }) => {
  return (
    <div className={`chart-wrapper w-full ${heightClass} relative`}>
      {children}
    </div>
  );
}
export default ChartWrapper;